
import { useEffect, useRef, useState } from 'react';
import { svgs } from '../assets/svgs'

export const CarouselSlider = ({ children, data }) => {
   const [touchPosition, setTouchPosition] = useState(null)
   const [slides, setSlides] = useState([]);
   const [indicators, setIindicators] = useState([]);
   const [currSlide, setCurrSlide] = useState(null);
   const [targetSlide, setTargetSlide] = useState(null);
   const slidesRef = useRef(null)
   const indicatorsRef = useRef(null)

   useEffect(() => {
      window.addEventListener('resize', handleResize);
      return () => {
         window.removeEventListener('resize', handleResize);
      };
   }, [])

   useEffect(() => {
      if (children.length === 0) return
      setSlides(Array.from(slidesRef.current.children));
      setIindicators(Array.from(indicatorsRef.current.children));
   }, [children])

   useEffect(() => {
      if (slides.length === 0) return
      const currSlide = slides.find(slide => slide.className.includes('curr-slide'))
      setCurrSlide(currSlide)
      handleResize()
   }, [slides])

   useEffect(() => {
      if (!targetSlide) return
      moveSlides()
   }, [targetSlide])

   const handleResize = () => {
      if (slides.length === 0) return
      slides.forEach((slide, slideIdx) => {
         slide.style.left = slides[0].getBoundingClientRect().width * slideIdx + 'px';
      })
   };

   const handleClick = (dir) => {
      setTargetSlide(dir === 'prev'
         ? currSlide?.previousElementSibling || slides[slides.length - 1]
         : currSlide?.nextElementSibling || slides[0])
   }

   const moveSlides = () => {
      if (!targetSlide || !currSlide) return
      slidesRef.current.style.transform = 'translateX(-' + targetSlide.style.left + ')'
      const currSlideIdx = slides.findIndex(slide => slide.className.includes('curr-slide'))
      currSlide.classList.remove('curr-slide')
      targetSlide.classList.add('curr-slide')
      const targetSlideIdx = slides.findIndex(slide => slide.className.includes('curr-slide'))
      changeIndicator(indicators[currSlideIdx], indicators[targetSlideIdx])
      setCurrSlide(targetSlide)
      setTargetSlide(null)
   }

   const handleIndicatorClick = (e) => {
      const targetIndicator = e.target.closest('button')
      if (!targetIndicator) return
      const currIndicator = indicators.find(indicator => indicator.className.includes('curr-indicator'))
      changeIndicator(currIndicator, targetIndicator)
      const targetIndicatorIdx = indicators.findIndex(indicator => indicator.className.includes('curr-indicator'))
      setTargetSlide(slides[targetIndicatorIdx])
   }

   const changeIndicator = (currIndicator, targetIndicator) => {
      if (!currIndicator || !targetIndicator) return
      currIndicator.classList.remove('curr-indicator')
      targetIndicator.classList.add('curr-indicator')
   }

   const handleTouchStart = (e) => {
      const touchDown = e.touches[0].clientX
      setTouchPosition(touchDown)
   }

   const handleTouchMove = (e) => {
      const touchDown = touchPosition
      if (touchDown === null) return
      const currentTouch = e.touches[0].clientX
      const diff = touchDown - currentTouch
      if (diff > 5) handleClick('next')
      if (diff < -5) handleClick('prev')
      setTouchPosition(null)
   }

   return (
      <div onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} className='carousel-slider'>
         <button onClick={() => handleClick('prev')}>{svgs.arrowLeft}</button>
         <div className="slides" ref={slidesRef}>
            {
               children.map((child, index) => (
                  <div key={index} className={index === 0 ? 'slide curr-slide' : 'slide'} >
                     {child}
                  </div>
               ))
            }
         </div>
         <button onClick={() => handleClick('next')}>{svgs.arrowRight}</button>
         <nav className="indicators" ref={indicatorsRef}>
            {
               data.map((item, index) => (
                  <button key={index} onClick={handleIndicatorClick} className={index === 0 ? 'indicator curr-indicator' : 'indicator'}>
                     {item?.image_url && <img className='round' src={item.image_url} alt={item.image_url} />}
                     {!item?.image_url && <span>🔵</span>}
                  </button>
               ))
            }
         </nav>
      </div>
   )
}
